// PaginationControlsInner.jsx - Compact, visually distinct pagination for nested/inner lists
import React from "react";

export const PaginationControlsInner = ({
  itemsPerPage,
  currentPage,
  totalPages,
  changeItemsPerPage,
  goToPage,
  nextPage,
  prevPage,
  Module,
}) => {
  return (
    <div
      className="d-flex justify-content-between align-items-center"
      style={{
        paddingTop: "10px",
        marginTop: "10px",
        borderTop: "1px dashed #e3e6f0",
      }}
    >
      {/* Items per page - compact select, no border, muted */}
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontSize: "0.72rem", color: "#8b8fa3" }}>Show</span>
        <select
          className="form-select form-select-sm"
          value={itemsPerPage}
          onChange={(e) => changeItemsPerPage(e.target.value)}
          style={{
            fontSize: "0.72rem",
            padding: "1px 22px 1px 8px",
            height: "24px",
            border: "1px solid #e3e6f0",
            borderRadius: "6px",
            backgroundColor: "#f7f8fc",
            color: "#4b3f9e",
            width: "auto",
          }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
        </select>
      </div>

      {/* Prev / Page indicator / Next */}
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            prevPage();
          }}
          disabled={currentPage === 1}
          style={{
            border: "1px solid #e3e6f0",
            backgroundColor: "#fff",
            color: currentPage === 1 ? "#c7c9d9" : "#4b3f9e",
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            fontSize: "0.65rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
            cursor: currentPage === 1 ? "default" : "pointer",
          }}
        >
          ‹
        </button>

        <span
          style={{
            fontSize: "0.72rem",
            color: "#6b6f85",
            backgroundColor: "#eef0fb",
            padding: "2px 10px",
            borderRadius: "20px",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            nextPage();
          }}
          disabled={currentPage === totalPages}
          style={{
            border: "1px solid #e3e6f0",
            backgroundColor: "#fff",
            color: currentPage === totalPages ? "#c7c9d9" : "#4b3f9e",
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            fontSize: "0.65rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
            cursor: currentPage === totalPages ? "default" : "pointer",
          }}
        >
          ›
        </button>
      </div>
    </div>
  );
};
